import styled from 'styled-components';

import colors from '../../../../../theme/colors';
import media from '../../../../../theme/media';

export const Container = styled.div`
    margin-bottom: ${(props) => (props.indentCompact ? '32px' : '48px')};

    ${media.desktop1920} {
        margin-bottom: ${(props) => (props.indentCompact ? '48px' : '72px')};
    }
`;
export const Title = styled.div`
    font-size: 24px;
    line-height: 36px;
    color: ${(props) => (props.useThemeColor ? props.theme.black : colors.baseColor)};
    text-align: ${(props) => (props.isCentered ? 'center' : 'left')};

    ${media.desktop1920} {
        font-size: 32px;
        line-height: 48px;
    }
`;
export const SubTitle = styled.div`
    font-size: 17px;
    line-height: 24px;
    color: ${(props) => (props.useThemeColor ? props.theme.grey_72_lc : colors.mediumGray)};
    margin-top: 16px;

    ${media.desktop1920} {
        font-size: 20px;
        line-height: 32px;
    }
`;
export const RowButton = styled.div`
    margin-top: 4px;
`;
